import { useRef } from "react";
import Image from "../images/Image";
import ToolTip from "../ToolTip/ToolTip";

interface UploadedContainerProps {
  fileName: string;
  onclickDelete: () => void
  handleManualUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  index?: number;
  uploadedContainerClass?: string;
}

export default function UploadedContainer({ fileName, onclickDelete, handleManualUpload, id, index, uploadedContainerClass }: UploadedContainerProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleReUploadClick = () => {
    // Trigger the file input click event
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  return (
    <div className={`${uploadedContainerClass ? uploadedContainerClass : 'w-80'} h-[52px] flex items-center justify-between bg-p_light border border-ozzzutline rounded-lg px-[18px] py-[14px]`}>
      <div className="relative group">
        {/* Tooltip container */}
        <h1 className="text-body1 text-primary_text truncate pr-4 w-[225px]" data-testid={index !== undefined ? `${id.replace(/_/g, '-')}-${index}` : id.replace(/_/g, '-')}>{fileName}</h1>
        {/* Tooltip */}
        <ToolTip ToolTipItem={fileName} />
      </div>
      <div className="flex gap-4">
        <Image src="delete" onClick={onclickDelete} className="cursor-pointer" testId={index !== undefined ? `delete_${id}_${index}` :  `delete_${id}`} />
        <Image src="re-upload" onClick={handleReUploadClick} className="cursor-pointer" />
        <input
          type="file" 
          id={id}
          ref={fileInputRef}
          className="hidden"
          data-testid="file-type-input"
          onChange={(e) => {
            if (e.target.files) {
              handleManualUpload(e);
            }
          }}
        />
      </div>

    </div>
  );
}
